<template>
  <mdb-container class="mt-2">

    <!--    Page main section-->

    <jumbotron :subtitle="$t('services.subtitle')" :title="$t('services.title')"></jumbotron>

    <!--    Buttons-->
    <mdb-row class="justify-content-center mt-3">
      <mdb-col v-if="services.length === 0">
        <mdb-alert class="alert alert-info">
          <p>{{ $t('general.emptyResult', {type: 'services', resource: resource.title}) }}</p>
        </mdb-alert>
      </mdb-col>
      <mdb-col v-for="(service, index) in services" :key="index" class="mb-3 selection-buttons" col="lg-6">
        <div :class="{'active' :  service.count}" class="selection-button">
          <div class="accessory-item">
            <h5>{{ service.title }}</h5>
            <p>{{ service.description }}</p>
            <p class="accessory-price" v-if="!settings.hide_price">
              {{ service.calculatedPrice | currencyFormat }}
              {{ $t('general.inclusiveTax') }}
<!--              {{ $t('general.per') }}-->
              {{ service.interval }}
            </p>
            <div class="counter-box">
              <div :style="{'opacity' : service.count === 0 ? 0.5 : 1}" class="counter-box-action"
                   @click.prevent="updateCount(service, -1)">
                <i class="fa fa-minus"></i>
              </div>
              <div class="counter-box-quantity">
                <input :max="service.quantity" :value="service.count" class="counter-box-input" min="0"
                       type="number" @input="updateService(service, $event)">
              </div>
              <div :style="{'opacity' : service.count === service.quantity ? 0.5 : 1}" class="counter-box-action"
                   @click.prevent="updateCount(service, 1)">
                <i class="fa fa-plus"></i>
              </div>
              <span class="counter-box-interval d-none">{{ service.interval }}</span>
            </div>
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <!--    Next button-->
    <mdb-row class="justify-content-center mt-3">
      <mdb-col>
        <mdb-btn block class="large-button btn-primary" @click="$router.push({name: 'AdditionalInfo'})">
          {{ $t('general.next') }}
        </mdb-btn>
      </mdb-col>
    </mdb-row>

  </mdb-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  name: 'Services',

  data() {
    return {}
  },

  metaInfo() {
    return {
      title: this.$t('services.title')
    }
  },

  mounted() {
    if (!this.services.length) {
      this.$store.dispatch("updateIsLoading", true)

      this.$http.getServices(this.resource.id)
          .then(({data}) => {
            if (data.success) {
              let services = data.data;
              services.map(item => {
                item.title = item.name;
                item.calculatedPrice = parseFloat((parseFloat(item.price) + (parseFloat(item.price) * item.tax / 100)).toFixed(2));
                item.count = 0;
                item.quantity = item.quantity ? parseInt(item.quantity, 10) : 0;
              })

              this.updateServices(services)

              if (this.services.length === 0) {
                this.$router.push({name: 'AdditionalInfo'})
              }

            }
          })
          .finally(() => this.$store.dispatch("updateIsLoading", false))
    }

  },

  computed: {
    ...mapGetters({
      services: "getServices",
      resource: "getResource",
      settings: "getSettings"
    })
  },

  methods: {

    ...mapActions(["updateServices"]),

    updateCount(service, increment) {

      let currentCount = parseInt(service.count, 10)
      if (increment === -1 && currentCount === 0) {
        return;
      }
      if (increment === 1 && currentCount === service.quantity) {
        return;
      }
      currentCount += increment;
      service.count = currentCount;
    },

    updateService(service, $event) {
      let count = parseInt($event.target.value, 10);
      if (!isNaN(count) ) {
        if(count >= 0 && count <= service.quantity){
          service.count = count;
          this.updateServices(this.services);
        }

        if (count > service.quantity){
          service.count =  service.quantity;
          $event.target.value = service.quantity
        }

      }
    }

  }

}
</script>

<style lang="scss" scoped>
@import "_index.scss";
</style>


// WEBPACK FOOTER //
// src/components/pages/services/index.vue